module.exports = __webpack_public_path__ + "static/img/fenge.53a0280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homes/fenge.png
// module id = QqA1
// module chunks = 1